import React from 'react';
import { withFormsy } from 'formsy-react';
import Datetime from 'react-datetime';

class FormsyDatetime extends React.Component {
    onChange = (value) => {
        this.props.setValue(value);

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {
        const {
            datetimeProps,
            getValue,
            getErrorMessages,
            placeholder,
            dateFormat,
            timeFormat,
            utc
        } = this.props;

        const value = getValue();
        const errors = getErrorMessages() || [];

        return (
            <>
                <Datetime
                    {...datetimeProps}
                    inputProps={{ placeholder: placeholder }}
                    value={value}
                    utc={utc}
                    dateFormat={dateFormat}
                    timeFormat={timeFormat}
                    onChange={this.onChange}
                />
                {
                    errors.map((error, index) => {
                        return (<div key={`datetime_error_${index}`}><span class="text-danger">{error}</span></div>)
                    })
                }
            </>
        );
    }
}

export default withFormsy(FormsyDatetime);
